import {
    COPY_TO_CLIPBOARD_SHARE_UTM_MEDIUM,
    COPY_TO_CLIPBOARD_SHARE_UTM_SOURCE,
    LINK_SHARE_UTM_MEDIUM,
} from '../constants';
import { NetworkWithOrWithoutConfig } from '../types';
import { getNetworkName } from './network';

export const removeSearchParamsFromUrl = (url: string): string => {
    const parsedUrl = new URL(url);
    parsedUrl.search = '';
    return parsedUrl.toString();
};

export const addUtmsToLinkShareUrl = (
    url: string,
    network: NetworkWithOrWithoutConfig
): string => {
    const networkName = getNetworkName(network);
    const params = `?utm_source=${networkName}&utm_medium=${LINK_SHARE_UTM_MEDIUM}`;
    return (url += params);
};

export const addUtmsToCopyToClipboardShareUrl = (url: string): string => {
    const params = `?utm_source=${COPY_TO_CLIPBOARD_SHARE_UTM_SOURCE}&utm_medium=${COPY_TO_CLIPBOARD_SHARE_UTM_MEDIUM}`;
    return (url += params);
};

export const replaceUrlInText = ({
    text,
    prevUrl,
    nextUrl,
}: {
    text: string;
    prevUrl: string;
    nextUrl: string;
}): string => {
    const urlRegex = new RegExp(
        prevUrl.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'),
        'g'
    );
    return text.replace(urlRegex, nextUrl);
};
